import { render, staticRenderFns } from "./highquality.vue?vue&type=template&id=0b38db2f&scoped=true"
import script from "./highquality.vue?vue&type=script&lang=js"
export * from "./highquality.vue?vue&type=script&lang=js"
import style0 from "./highquality.vue?vue&type=style&index=0&id=0b38db2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38db2f",
  null
  
)

export default component.exports